class pageTop {
  constructor(el, opt) {
    this.el = el;
    if(document.querySelector('.js-top-banner-swiper')){
      this.mobileBannerSwiper()
    }
  }
  mobileBannerSwiper() {
    const swiperWrap = document.querySelector('.js-top-banner-swiper');
    new Swiper(swiperWrap,{
      loop: true,
      slidesPerShow: 1,
      centeredSlides: true,
      spaceBetween: 2,
      pagination: {
        el: '.js-top-banner-swiper__pagination',
        type: 'bullets'
      }
    })
  }
}

class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    // スマホ判別
    Alpine.store('isMobile', window.innerWidth <= 768);

    function checkScreenSize() {
      Alpine.store('isMobile', window.innerWidth <= 768);
    }

    window.addEventListener('resize', checkScreenSize);

    // メガメニュー開閉用
    Alpine.store('megaMenu', false);
    // スマホメニュー開閉用
    Alpine.store('spMenu', false);
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class GoodsSwiper {
  constructor(el,opt){
    this.el = el;
    if(document.querySelector('.js-goods-swiper')){
      this.event()
    }
  }
  event(){
    const swiperEle = '.js-goods-swiper';
    new Swiper(swiperEle,{
      loop: true,
      spaceBetween: 2,
      navigation: {
        nextEl: '.js-goods-swiper__next',
        prevEl: '.js-goods-swiper__prev',
      },
      pagination: {
        el: '.js-goods-swiper__pagination',
        type: 'bullets',
        clickable: true
      }
    })
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

var currentInfoWindow = null;
var marker = [];
var infoWindow = [];
var map;

function initializeMap() {
	var latlng = new google.maps.LatLng(36.350595, 139.826106);
	var markerData = [ // マーカーを立てる場所名・緯度・経度
		{
			name: '本店',
			address: '小山市神鳥谷1-11-32',
			lat: 36.30148,
			lng: 139.79031,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: 'おやま広域農機センター',
			address: '小山市大字小袋170-2',
			lat: 36.313764,
			lng: 139.754415,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: '西部青果物集出荷所',
			address: '小山市大字小袋201',
			lat: 36.314628,
			lng: 139.754482,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},
		{
			name: '大谷支店',
			address: '小山市横倉新田7-33',
			lat: 36.272965,
			lng: 139.822936,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '間々田支店',
			address: '小山市乙女3-7-36',
			lat: 36.261421,
			lng: 139.762963,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '美田支店',
			address: '小山市小袋202-1',
			lat: 36.315276,
			lng: 139.754979,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '桑絹支店',
			address: '小山市出井1083-3',
			lat: 36.336386,
			lng: 139.851328,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '小山支店',
			address: '小山市神鳥谷1-11-32',
			lat: 36.301626,
			lng: 139.790539,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '下野支店',
			address: '下野市笹原135-1',
			lat: 36.40264,
			lng: 139.85351,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '野木支店',
			address: '野木町中谷523-1',
			lat: 36.223414,
			lng: 139.746331,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin2.png'
		},
		{
			name: '思川ホール',
			address: '小山市萩島134',
			lat: 36.31151,
			lng: 139.777059,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin3.png'
		},
		{
			name: 'おとめホール',
			address: '小山市南乙女2-1-6',
			lat: 36.255338,
			lng: 139.752339,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin3.png'
		},
		{
			name: '東部営農支援センター（のぞみ館東部）',
			address: '小山市大字東黒田313－2（東部集出荷所敷地内）',
			lat: 36.253596,
			lng: 139.789343,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '西部営農支援センター（のぞみ館西部）',
			address: '小山市大字小袋201（西部集出荷所敷地内）',
			lat: 36.314628,
			lng: 139.754482,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '北部営農支援センター（のぞみ館北部）',
			address: '下野市小金井5-22-2',
			lat: 36.375659,
			lng: 139.836267,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'のぞみ館野木',
			address: '下都賀郡野木町友沼4954-1',
			lat: 36.235212,
			lng: 139.727250,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '桑東部出張所',
			address: '小山市大字出井1083-3',
			lat: 36.336333,
			lng: 139.851211,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '石橋下古山購買所',
			address: '下野市石橋531-3',
			lat: 36.438754,
			lng: 139.86033,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'グリーンセンター',
			address: '小山市乙女3-7-36（間々田支店敷地内）',
			lat: 36.261441,
			lng: 139.763000,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'のぎ松原大橋直売所',
			address: '野木町大字友沼4954-1（のぞみ館野木敷地内）',
			lat: 36.235242,
			lng: 139.727298,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '国分寺農産物直売所',
			address: '下野市小金井5-22-2（北部営農支援センター敷地内）',
			lat: 36.375689,
			lng: 139.836297,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'よらっせ桑',
			address: '小山市扶桑1-4-13',
			lat: 36.355273,
			lng: 139.817582,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '石橋農産物直売所「四季彩」',
			address: '下野市石橋531－3（石橋支店敷地内）',
			lat: 36.438784,
			lng: 139.86063,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '道の駅思川',
			address: '小山市下国府塚25-1',
			lat: 36.308223,
			lng: 139.760499,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: '道の駅しもつけ',
			address: '下野市薬師寺3720-1',
			lat: 36.397152,
			lng: 139.883792,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ヨークベニマル小山ゆうえんち店直売所',
			address: '小山市喜沢1475-182（ヨークベニマル店舗内）',
			lat: 36.334016,
			lng: 139.809421,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ヨークベニマル雨ヶ谷店直売所',
			address: '小山市雨ヶ谷町61（ヨークベニマル店舗内）',
			lat: 36.284087,
			lng: 139.812321,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'イオン小山店直売所',
			address: '小山市中久喜1467-1（イオン店舗内）',
			lat: 36.321371,
			lng: 139.840439,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'ベイシアスーパーマーケット小山店直売所',
			address: '小山市立木934-1（ベイシア店舗内）',
			lat: 36.328378,
			lng: 139.789039,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
		{
			name: 'TAIRAYA小金井店直売所',
			address: '下野市駅東2-7-4（TAIRAYA店舗内）',
			lat: 36.374580,
			lng: 139.845380,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin5.png'
		},
        {
			name: '美田支店 2階',
			address: '小山市小袋202-1',
			lat: 36.315276,
			lng: 139.754979,
			icon: '../wp-content/themes/ja-oyama/images/post/shop/pin1.png'
		},

	];

	var myOptions = {
		zoom: 11,
		center: latlng,
		mapTypeId: google.maps.MapTypeId.ROADMAP, //
		panControl: true, //1.左上の丸いの表示
		streetViewControl: true, //2.左の黄色い人形(pegman=ペグマン)表示
		zoomControl: true, //3.左の上下スライダー表示
		mapTypeControl: true, //4.右上の「地図/航空写真」表示
		scaleControl: false, //5.右下の定規の表示
		overviewMapControl: false, //6.右下の概観マップの表示
		//disableDefaultUI: true  //全コントローラを非表示
		scrollwheel: false
	};

	map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);

	// マーカー毎の処理
	for (var i = 0; i < markerData.length; i++) {
		const markerLatLng = new google.maps.LatLng({lat: markerData[i]['lat'], lng: markerData[i]['lng']}); // 緯度経度のデータ作成
		marker[i] = new google.maps.Marker({ // マーカーの追加
			position: markerLatLng, // マーカーを立てる位置を指定
			map: map // マーカーを立てる地図を指定
		});

		infoWindow[i] = new google.maps.InfoWindow({ // 吹き出しの追加
			content: '<div class="map-info"><h5>' + markerData[i]['name'] + '</h5><p>' + markerData[i]['address'] + '</p></div>' // 吹き出しに表示する内容
		});

		markerEvent(i); // マーカーにクリックイベントを追加
		marker[i].setOptions({
			icon: {
				url: markerData[i]['icon']// マーカーの画像を変更
			}
		});
	}

	$("a.map-jump").each(function(){
		jQuery(this).bind("click", function(){
			if (currentInfoWindow) {
				currentInfoWindow.close();
			}
			var infoWindowNum = $(this).attr('mapnum');
			infoWindow[infoWindowNum].open(map, marker[infoWindowNum]);
			currentInfoWindow = infoWindow[infoWindowNum];
		});
	});
}
function markerEvent(i) {
	marker[i].addListener('click', function() { // マーカーをクリックしたとき

		if (currentInfoWindow) {
			currentInfoWindow.close();
		}

		infoWindow[i].open(map, marker[i]);
		currentInfoWindow = infoWindow[i];
	});
}
// google.maps.event.addDomListener(window , 'load' , initializeMap());

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  new pageTop();
  new GoodsSwiper();
});

document.addEventListener('alpine:init', () => {
  new AlpineStore();
})